import React, { ReactNode } from 'react';
import { Tooltip } from 'react-tooltip';
import styles from './styles.module.scss';

// Type mapping for placement compatibility
type Placement = 'top' | 'bottom' | 'left' | 'right';

interface TooltipProps {
  title: string;
  children: ReactNode;
  placement?: Placement;
}

const InsertedFieldsTooltip = ({ children, title, placement = 'top' }: TooltipProps) => {
  // Sanitize title to create valid CSS selector ID by replacing all non-alphanumeric characters with hyphens
  const tooltipId = `insert-tooltip-${title.replace(/[^a-zA-Z0-9-]/g, '-').toLowerCase()}-${Date.now()}`;

  return (
    <>
      <span id={tooltipId}>{children}</span>
      <Tooltip
        anchorSelect={`#${tooltipId}`}
        place={placement}
        className={styles.primaryTooltip}
        data-testid={`insert-tooltip-${title}`}
        style={{
          backgroundColor: '#ddebef',
          color: '#18191b',
          maxWidth: '320px',
          zIndex: 99999,
          fontSize: '14px',
          padding: '8px',
          borderRadius: '4px',
        }}
        opacity={1}
      >
        {title}
      </Tooltip>
    </>
  );
};

export default InsertedFieldsTooltip;
